import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({

  selectTypeTitle: {
    id: 'authoring.problemEditor.selectType.title',
    defaultMessage: 'Seleccionar tipo de problema',
    description: 'Title for select problem type modal',
  },
  cancelButtonLabel: {
    id: 'authoring.problemeditor.selecttype.cancelButton.label',
    defaultMessage: 'Cancelar',
    description: 'Label for cancel button.',
  },
  cancelButtonAriaLabel: {
    id: 'authoring.problemeditor.selecttype.cancelButton.ariaLabel',
    defaultMessage: 'Cancelar',
    description: 'Screen reader label for cancel button.',
  },
  selectButtonLabel: {
    id: 'authoring.problemeditor.selecttype.selectButton.label',
    defaultMessage: 'Seleccionar',
    description: 'Label for select button.',
  },
  selectButtonAriaLabel: {
    id: 'authoring.problemeditor.selecttype.selectButton.ariaLabel',
    defaultMessage: 'Seleccionar',
    description: 'Screen reader label for select button.',
  },
});

export default messages;
